import { render, staticRenderFns } from "./ItemListVariazioneOrdineMTM.vue?vue&type=template&id=fc7b8516"
import script from "./ItemListVariazioneOrdineMTM.vue?vue&type=script&lang=ts"
export * from "./ItemListVariazioneOrdineMTM.vue?vue&type=script&lang=ts"
import style0 from "./ItemListVariazioneOrdineMTM.vue?vue&type=style&index=0&id=fc7b8516&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc7b8516')) {
      api.createRecord('fc7b8516', component.options)
    } else {
      api.reload('fc7b8516', component.options)
    }
    module.hot.accept("./ItemListVariazioneOrdineMTM.vue?vue&type=template&id=fc7b8516", function () {
      api.rerender('fc7b8516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListVariazioneOrdineMTM.vue"
export default component.exports